module.exports = {
    abnLookup: {
        errorMessage: `Unable to find a match for your ABN. Please check the number you have entered.
            Alternatively, call 1300 665 386 or email business@woolworths.com.au to sign up with us`,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/abn-lookup.js